import WidgetEntity from '../WidgetEntity';

export default class QuickQuestionWidget extends WidgetEntity {
  static make(
    type,
    pageId,
    sortOrder,
    allowFreeTextResponse = false,
    replyPageId = undefined,
  ) {
    return {
      ...super.make(pageId, type, 'Untitled question', sortOrder),
      buttons: [],
      config: {
        pageId: replyPageId,
        body: '',
        allowFreeTextResponse,
      },
    };
  }
}
